import cloneDeep from 'lodash.clonedeep';
import set from 'lodash.set';
import get from 'lodash.get';

import types from './constants';
import { states } from '../../values/enums';
import reportReducers from '../reducers';

const defaultReducer = (state, action) => (state)

const reportPending = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.PENDING})
  return next
}

const reportComplete = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.COMPLETE});
  set(next, 'report.data', action.report);
  return next
}

const reportError = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.ERROR, data: action.error})
  return next
}

const actionReducer = Object.assign({
  [types.SKILLSDIAGNOSTIC_PENDING]: reportPending,
  [types.SKILLSDIAGNOSTIC_COMPLETE]: reportComplete,
  [types.SKILLSDIAGNOSTIC_ERROR]: reportError,
}, reportReducers);

const initialState = {
  report: null,
}

export default (state=initialState, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer
  return reducer(state, action)
}